<template>
    <div v-show="visible">
        <el-dialog
            title="发货"
            :close-on-click-modal="false"
            :visible.sync="visible"
            width="420px"
            :before-close="dialogClose">
            <el-form ref="form" :model="form" :rules="rules" label-width="90px">
                <el-form-item label="订单号">
                    <el-input v-model="form.orderId" readonly></el-input>
                </el-form-item>
                <el-form-item label="快递单号" prop="expressNo">
                    <el-input v-model="form.expressNo" maxlength="100" clearable placeholder="请输入快递单号"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" :loading="saving" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import http from '../../../../common/http';

export default {
    mixins: [http],
    data() {
        return {
            visible: false,
            saving: false,
            onSuccess: null,
            form: {
                orderId: '',
                expressNo: ''
            },
            rules: {
                expressNo: [
                    { required: true, message: '请输入快递单号', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        init(row, onSuccess) {
            this.visible = true;
            this.onSuccess = onSuccess;
            this.form.orderId = row.orderId || '';
            this.form.expressNo = '';
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },
        save() {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.saving = true;
                const url = this.memberOrderDeliveryUrl;
                const data = {
                    orderId: this.form.orderId,
                    expressNumber: this.form.expressNo
                };
                this.apiPost(url, data).then((res) => {
                    this.saving = false;
                    if (res.status === 200) {
                        this.$commonFn.showTip(res.message, 1);
                        this.visible = false;
                        if (typeof this.onSuccess === 'function') {
                            this.onSuccess();
                        }
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                }, (err) => {
                    console.log(err);
                    this.saving = false;
                });
            });
        },
        dialogClose(done) {
            done();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/page/member/order/OrderDelivery.vue